import { provideZoneChangeDetection } from '@angular/core';

import { AppModule } from './app/app.module';
import { SettingsLoaderService } from '@cupoui/core/services/settings.loader.service';
import { KEYCLOAK_CONFIG } from '@cupoui/shared/util/keycloak-runtime-config';
import {platformBrowser} from "@angular/platform-browser";

async function startApp() {
  const settings = await fetch(SettingsLoaderService.CONFIG_URL);
  const dynamicKeycloakConfig = await settings.json();

  await platformBrowser([{ provide: KEYCLOAK_CONFIG, useValue: dynamicKeycloakConfig.keycloak }]).bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()]
  });
}

startApp()
  .then(() => console.debug('Application started'))
  .catch(err => console.error(err));
